import { onFindPivotPreviewItemsSuccess } from '../actions/internalActions';
import { findItemWithStartIndex, getFindItemShape } from 'owa-mail-store';
import { orchestrator } from 'satcheljs';
import { getMailItemSortByProperty } from 'owa-mail-list-actions';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import getHashtagsToInclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToInclude';
import getHashtagsToExclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToExclude';
import FindItemResponseMessage from 'owa-service/lib/contract/FindItemResponseMessage';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { showPivotEnableDisableDialog } from '../actions/publicActions';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { MailFolderTableQuery, getBaseFolderId } from 'owa-mail-list-store';

orchestrator(showPivotEnableDisableDialog, actionMessage => {
    const inboxFolderId = folderNameToId('inbox');
    const tableQuery = createMailFolderTableQuery(
        inboxFolderId,
        ReactListViewType.Message,
        'mail',
        FocusedViewFilter.None,
        'All'
    ) as MailFolderTableQuery;
    const pivotsToPreview = [
        InboxClassificationFilter.Promotions,
        InboxClassificationFilter.Social,
        InboxClassificationFilter.Newsletters,
    ];

    for (const pivot of pivotsToPreview) {
        findItemWithStartIndex(
            getBaseFolderId(tableQuery),
            0 /* startIndex */,
            20 /* rowsToLoad */,
            'All' /* viewFilter */,
            getMailItemSortByProperty(tableQuery),
            FocusedViewFilter.None,
            getFindItemShape(),
            false,
            getMailboxInfoFromTableQuery(tableQuery).requestOptions,
            tableQuery.categoryName,
            getHashtagsToInclude(pivot),
            getHashtagsToExclude(pivot)
        ).then((responseMessage: FindItemResponseMessage) => {
            if (responseMessage.ResponseClass == 'Success') {
                onFindPivotPreviewItemsSuccess(pivot, responseMessage.RootFolder.Items);
            }
        });
    }
});
